import { render } from "./StudentsForm.vue?vue&type=template&id=35c3fedd"
import script from "./StudentsForm.vue?vue&type=script&lang=js"
export * from "./StudentsForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__